import React, { useEffect, useState } from 'react'
import { useList } from 'react-firebase-hooks/database'
import { useDispatch } from 'react-redux'
import { Link, useHistory } from 'react-router-dom'
import { toast } from 'react-toastify'
import styled from 'styled-components'
import LoadIcon from '../components/LoadIcon'
import PageWithBg from '../components/PageWithBg'
import SideAgenda from '../components/SideAgenda'
import config from '../config'
import { muteMusic, showGlobalModal, unmuteMusic } from '../ducks/layout'
import { RoomDb } from '../firebaseConfig'
import routes from '../routes'
import { COLORS, SIZES } from '../styles/theme'
import Amplitude from '../utils/amplitudeHelper'

const Page = styled.div`
  overflow: hidden;
  .content {
    ${config.layout.auditoriumVid}
    position: absolute;
    background: black;

    iframe {
      height: 100%;
      width: 100%;
    }
  }
  .chat {
    max-width: 350px;
    position: fixed;
    padding-top: ${SIZES.navHeight};
    top: 0;
    left: 70%;
    bottom: 0;
    right: 5%;
    z-index: 30;
  }
  .attendance {
    /* border: 1px solid red; */
    position: fixed;
    bottom: 17%;
    left: 5%;
    right: 36.5%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
  }
  .action-button {
    display: inline-block;
    background: linear-gradient(#ff9821, #f83636);
    border: 2px solid white;
    text-decoration: none;
    color: ${COLORS.hotButtonText};
    padding: 6px 20px;
    font-weight: 600;
    cursor: pointer;
    border-radius: 50px;
    width: 245px;
    height: 45px;
    white-space: nowrap;
  }

  .action-button-live {
    display: inline-block;
    background: linear-gradient(270deg, #fe1e9a, #254dde);
    border: 2px solid white;
    text-decoration: none;
    color: ${COLORS.hotButtonText};
    padding: 6px 20px;
    font-weight: 600;
    cursor: pointer;
    border-radius: 50px;
    width: 245px;
    height: 45px;
    white-space: nowrap;
  }

  .prev-btn,
  .next-btn {
    position: absolute;
    bottom: 5%;
    text-decoration: none;
    background: linear-gradient(#ff9821, #f83636);
    color: ${COLORS.hotButtonText};
    border-radius: 32px;
    border: 2px solid #ff9821;
    padding: 8px 16px;
    text-align: center;
    box-shadow: 0px 5px 4px -4px #000;
    p {
      margin: 0 auto;
    }
  }
  .prev-btn {
    left: 5%;
  }
  .next-btn {
    right: 36.5%;
  }
`

export default function AuditoriumPage({ liveUrl, hallNumber, currentUser }) {
  const [loading, setLoading] = useState(true)
  const [sidebar, setSidebar] = useState(false)
  const [videoUrl, setVideoUrl] = useState()
  const [snapshots] = useList(RoomDb)
  const dispatch = useDispatch()
  const [status, setStatus] = useState(false)
  const [recording, setRecording] = useState(false)
  const history = useHistory()

  useEffect(() => {
    dispatch(muteMusic())

    return () => {
      if (localStorage.getItem('muted') === 'false') {
        dispatch(unmuteMusic())
      }
    }
  }, [dispatch])

  useEffect(() => {
    if (hallNumber == 1) {
      if (snapshots.length) {
        let hall = snapshots.filter((item) => {
          if (item.val().hallNumber === hallNumber) {
            return item
          }
        })
        setStatus(hall[0].val().active)
        if (!hall[0].val().active) {
          if (currentUser.role !== 'superadmin') {
            history.push(routes.lobby)
            toast('The Auditorium Hall will reopen tomorrow at 8am.')
          }
        }
      }
    }
  }, [snapshots])

  useEffect(() => {
    document.title = `${config.eventName} | Conference`
    Amplitude.visit(`Auditorium ${hallNumber} `)
  }, [currentUser.id, hallNumber])

  const toggleSpeakerSide = () => {
    Amplitude.clickSpeaker()
    dispatch(showGlobalModal('speaker'))
  }

  const displayAgenda = () => {
    Amplitude.clickAgenda()
    dispatch(showGlobalModal('agenda'))
  }

  const toggleSidebar = () => {
    if (sidebar === false) {
      Amplitude.clickProgrammeButton()
    }
    setSidebar(!sidebar)
  }

  const handlePlayback = (session) => {
    if (session.vimeo_id !== '') {
      Amplitude.watchRecording(session.id)
      setVideoUrl(`https://player.vimeo.com/video/${session.vimeo_id}`)
      setSidebar(false)
      setLoading(false)
    } else if (session.redirect_url) {
      console.log(session.redirect_url)
    }
  }

  const handleRecording = () => {
    Amplitude.watchPlayback()
    setVideoUrl(true)
    setRecording(true)
  }

  const handleLive = () => {
    setVideoUrl(undefined)
    setRecording(false)
  }

  const getNextHall = () => {
    return hallNumber + 1
  }
  const getPreviousHall = () => {
    return hallNumber - 1
  }

  return (
    <>
      {loading && <LoadIcon />}
      <Page style={{ opacity: loading ? 0 : 1 }}>
        {sidebar && (
          <SideAgenda open={sidebar} toggleSidebar={toggleSidebar} handlePlayback={handlePlayback} hallNumber={hallNumber} currentUser={currentUser} />
        )}
        <PageWithBg bgImg={config.assets.auditorium1.landscape}>
          <div className="content">
            <iframe
              title="Live Broadcast"
              src={
                hallNumber == 1 && videoUrl == undefined
                  ? `${liveUrl}?autoplay=1`
                  : hallNumber == 1 && videoUrl == true
                  ? 'https://player.vimeo.com/video/598881061?h=5b9fab1594&autoplay=1'
                  : videoUrl
                  ? `${videoUrl}?autoplay=1`
                  : `https://player.vimeo.com/video/608131148?h=9ff1d27a73&autoplay=1&loop=1`
              }
              allow="autoplay; fullscreen"
              allowFullScreen
              frameBorder="0"
              onLoad={() => {
                setLoading(false)
              }}
            />
          </div>
          <div className="chat h-100">
            <iframe src="https://app.sli.do/event/opytiuns" height="100%" width="100%" frameBorder="0" style={{ minHeight: '560px' }} title="Slido" />
          </div>

          <div className="attendance">
            {hallNumber === 5 ? (
              <div>
                <button type="button" className="action-button" onClick={toggleSidebar}>
                  KNOWLEDGE SHARING
                </button>
              </div>
            ) : hallNumber === 1 ? (
              recording ? (
                <div>
                  <button type="button" className="action-button-live" onClick={handleLive}>
                    WATCH LIVE STREAM
                  </button>
                </div>
              ) : (
                <div>
                  <button type="button" className="action-button" onClick={handleRecording}>
                    DAY 1 RECORDING
                  </button>
                </div>
              )
            ) : (
              <div>
                <button type="button" className="action-button" onClick={toggleSidebar}>
                  PAPER PRESENTERS
                </button>
              </div>
            )}
            <div>
              <button type="button" className="action-button" onClick={displayAgenda}>
                PROGRAMME
              </button>
            </div>
            <div>
              <button type="button" className="action-button" onClick={toggleSpeakerSide}>
                SPEAKERS
              </button>
            </div>
          </div>
          {hallNumber !== 1 && (
            <Link to={`/auditorium-hall/${getPreviousHall()}`} className="prev-btn">
              <p>
                <svg width="13px" height="22px" viewBox="0 0 13 22">
                  <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g transform="translate(-209.000000, -3123.000000)">
                      <g transform="translate(100.000000, 3068.000000)">
                        <g transform="translate(103.000000, 54.000000)">
                          <polygon points="0 0 24 0 24 24 0 24"></polygon>
                          <path
                            fill={COLORS.hotButtonText}
                            d="M13.5,5.5 C14.6,5.5 15.5,4.6 15.5,3.5 C15.5,2.4 14.6,1.5 13.5,1.5 C12.4,1.5 11.5,2.4 11.5,3.5 C11.5,4.6 12.4,5.5 13.5,5.5 Z M9.8,8.9 L7.24,21.81 C7.11,22.42 7.59,23 8.22,23 L8.3,23 C8.77,23 9.17,22.68 9.28,22.22 L10.9,15 L13,17 L13,22 C13,22.55 13.45,23 14,23 C14.55,23 15,22.55 15,22 L15,16.36 C15,15.81 14.78,15.29 14.38,14.91 L12.9,13.5 L13.5,10.5 C14.57,11.74 16.12,12.63 17.86,12.91 C18.46,13 19,12.52 19,11.91 C19,11.42 18.64,11.01 18.15,10.93 C16.63,10.68 15.37,9.78 14.7,8.6 L13.7,7 C13.14,6.11 12.02,5.75 11.05,6.16 L7.22,7.78 C6.48,8.1 6,8.82 6,9.63 L6,12 C6,12.55 6.45,13 7,13 C7.55,13 8,12.55 8,12 L8,9.6 L9.8,8.9 Z"
                          ></path>
                        </g>
                      </g>
                    </g>
                  </g>
                </svg>
              </p>
              <p>To {hallNumber === 2 ? 'Main Auditorium' : `Concurrent Room ${hallNumber - 2}`}</p>
            </Link>
          )}

          {hallNumber !== 5 && (
            <Link to={`/auditorium-hall/${getNextHall()}`} className="next-btn">
              <p>
                <svg width="13px" height="22px" viewBox="0 0 13 22">
                  <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g transform="translate(-209.000000, -3123.000000)">
                      <g transform="translate(100.000000, 3068.000000)">
                        <g transform="translate(103.000000, 54.000000)">
                          <polygon points="0 0 24 0 24 24 0 24"></polygon>
                          <path
                            fill={COLORS.hotButtonText}
                            d="M13.5,5.5 C14.6,5.5 15.5,4.6 15.5,3.5 C15.5,2.4 14.6,1.5 13.5,1.5 C12.4,1.5 11.5,2.4 11.5,3.5 C11.5,4.6 12.4,5.5 13.5,5.5 Z M9.8,8.9 L7.24,21.81 C7.11,22.42 7.59,23 8.22,23 L8.3,23 C8.77,23 9.17,22.68 9.28,22.22 L10.9,15 L13,17 L13,22 C13,22.55 13.45,23 14,23 C14.55,23 15,22.55 15,22 L15,16.36 C15,15.81 14.78,15.29 14.38,14.91 L12.9,13.5 L13.5,10.5 C14.57,11.74 16.12,12.63 17.86,12.91 C18.46,13 19,12.52 19,11.91 C19,11.42 18.64,11.01 18.15,10.93 C16.63,10.68 15.37,9.78 14.7,8.6 L13.7,7 C13.14,6.11 12.02,5.75 11.05,6.16 L7.22,7.78 C6.48,8.1 6,8.82 6,9.63 L6,12 C6,12.55 6.45,13 7,13 C7.55,13 8,12.55 8,12 L8,9.6 L9.8,8.9 Z"
                          ></path>
                        </g>
                      </g>
                    </g>
                  </g>
                </svg>
              </p>
              <p> To {hallNumber === 4 ? `Knowledge Sharing Lounge` : `Concurrent Room ${hallNumber}`}</p>
            </Link>
          )}
        </PageWithBg>
      </Page>
    </>
  )
}
